import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { FocusTrapInstance, focusTrap, getFocusableElements } from '@app/utils';

@Component({
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class PopoverComponent implements AfterViewInit, OnDestroy {
	active = false;
	trapFocus = true;
	focusTrap: FocusTrapInstance;
	panelClass: string;

	constructor(private readonly element: ElementRef<HTMLDivElement>) {}

	ngAfterViewInit(): void {
		if (this.trapFocus) {
			const elements = getFocusableElements(this.element.nativeElement);

			// Check the popover contains focusable elements
			if (elements && elements.length) {
				this.focusTrap = focusTrap(this.element.nativeElement);

				// Start trapping the focus
				this.focusTrap.start(elements[0]);
			}
		}
	}

	ngOnDestroy(): void {
		if (this.focusTrap) {
			// Stop focus trapping
			this.focusTrap.stop();
		}
	}
}
